import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class WorkdocStore extends ApiStore{
  constructor() {
    super();
  }


  loadFolderStucture(category,completeFunc,errorFunc){
    axios.get('/quotationfile/folder_structure/'+category)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      errorFunc(error)
      console.log(error);
    })    
  }

  loadExcelData(category,fileId,completeFunc,errorFunc){

    axios.get('/quotationfile/excel_data/'+category+'/'+fileId)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      errorFunc(error)
      console.log(error);
    }) 
  }

  loadItemWageSuggestion(query,completeFunc,errorFunc){
    axios.get('/quotationfile/itemwagesuggestion/?format=json&q='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      errorFunc(error)
      console.log(error);
    })
  }

  loadItemPartSuggestion(query,completeFunc,errorFunc){
    axios.get('/quotationfile/itempartsuggestion/?format=json&q='+query)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      errorFunc(error)
      console.log(error);
    })
  }

  saveExcelData(category,fileId,fileName,content,completeFunc,errorFunc){
    let postData = {file_name:fileName,content:content}
    console.log('postData=>',postData)
    
    axios.post('/quotationfile/excel_data/'+category+'/'+fileId, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }


  saveFolderStructureChange(category,postData,completeFunc,errorFunc){

    axios.post('/quotationfile/folder_structure_change/'+category, postData)
    .then(function (response) {
      console.log('response',response.data)
      let result = response.data
      if (result.status == 'OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({ status: 'error', desc: error });
    })
  }
  
}

export default new WorkdocStore()



// WEBPACK FOOTER //
// ./src/stores/QOFileStore.js